export const toggleMySnow = ({ name, url, locationId }) => {
  const meta = document.querySelector("meta[name=csrf-token]")
  const token = meta ? meta.content : ""
  const path = new URL(url, window.location.origin).pathname // eslint-disable-line compat/compat

  const formData = new FormData()
  formData.append("favourite[name]", name)
  formData.append("favourite[url]", path)
  formData.append("favourite[location_id]", locationId)

  return fetch("/favourites/toggle", {
    credentials: "include",
    method: "POST",
    headers: {
      "X-CSRF-Token": token,
    },
    body: formData,
  })
    .then((response) => {
      if (response.redirected) {
        window.location.href = response.url
        throw new Error("RedirectToLogin")
      }
      if (!response.ok) throw new Error(`${response.status}: ${response.statusText}`)
      return response.json()
    })
    .then((data) => data.isFavourite)
}

export function clickListener(event) {
  event.preventDefault()
  this.disabled = true

  const locationId = this.getAttribute("data-location-id")
  const locationFilename = window.FCGON?.location_filename || window.FCGON?.locationFilename
  const isMemberMode = window.FCGON?.member_mode ?? window.FCGON?.memberMode
  const defaultTab = isMemberMode ? "16-day" : "6day"
  const url =
    locationId && locationFilename
      ? `/resorts/${locationFilename}/${defaultTab}/mid`
      : window.location.href
  const favouriteName = this.getAttribute("data-favourite-name") || document.title

  toggleMySnow({ name: favouriteName, url, locationId })
    .then((isFavourite) => {
      this.disabled = false

      if (isFavourite) this.classList.add("is-favourite")
      else this.classList.remove("is-favourite")
    })
    .catch((err) => {
      this.disabled = false
      if (err.message !== "RedirectToLogin") {
        /* eslint-disable-next-line no-console */
        console.error(err)
      }
    })
}
